import httpService from '@/api/httpService'

const DashboardApi = (() => {
  const apiPostfix = 'dashboard'

  return {
    apiPostfix: apiPostfix,

    async getNews (page) {
      const response = await httpService.get(`${apiPostfix}/get_news/${page}`)
      return response.data
    }
  }
})()

export default DashboardApi
